import email from "@/assets/icons/email.png"
import instagram from "@/assets/icons/instagram.png"
import facebook from "@/assets/icons/facebook.png"
import twitter from "@/assets/icons/twitter.png"
import playstore from "@/assets/icons/playstore.png"

const icons = {
    email,
    instagram,
    facebook,
    twitter,
    playstore
}

export const socialLinks = [
    {
        nome: "Email",
        icon: icons.email,
        link:
            "mailto:blackpaladinsgames@gmail.com"
    },

    {
        nome: "Instagram",
        icon: icons.instagram,
        link:
            "https://instagram.com/blackpaladins"
    },

    {
        nome: "Facebook",
        icon: icons.facebook,
        link:
            "https://facebook.com/paladinsblack"
    },

    {
        nome: "Twitter",
        icon: icons.twitter,
        link:
            "https://x.com/paladins_black"
    },

    {
        nome: "Play Store",
        icon: icons.playstore,
        link:
            "https://play.google.com/store/apps/dev?id=7607519243151491071"
    }
]
export const contact = {
    pt: {
        titleFirst: "Entre em",

        titleSecond: "Contato",

        description:
            "Estamos prontos para ouvir sua ideia e transformá-la em realidade",

        emailTitle: "E-MAIL",

        locationTitle: "LOCALIZAÇÃO",

        socialTitle: "NOSSAS REDES",

        socialDescription:
            "Nos siga e fique por dentro de todas as novidades.",

        namePlaceholder: "Nome",

        emailPlaceholder: "E-mail",

        messagePlaceholder:
            "Conte-nos sobre seu projeto...",

        selectSubject:
            "Selecione um assunto",

        selectBudget:
            "Orçamento Estimado",

        send:
            "ENVIAR MENSAGEM",

        robotConfirm:
            "Confirme que você não é um robô.",

        messageSentTitle:
            "Mensagem Enviada!",

        messageSentDescription:
            "Entraremos em contato em breve.",

        subjects: [
            "Desenvolver um Projeto",
            "Proposta de Parceria",
            "Contratação Freelance",
            "Outro"
        ],

        budgets: [
            "Até $1.000",
            "$1.000 - $3.000",
            "$3.000 - $10.000",
            "Acima de $10.000"
        ],

        contactInfo: {
            email:
                "blackpaladinsgames@gmail.com",

            location:
                "Brasil - Trabalho Remoto"
        },
    },
    en: {
        titleFirst: "Get in",

        titleSecond: "Contact",

        description:
            "We are ready to hear your idea and turn it into reality",

        emailTitle: "EMAIL",

        locationTitle: "LOCATION",

        socialTitle: "OUR SOCIALS",

        socialDescription:
            "Follow us to stay updated on all news.",

        namePlaceholder: "Name",

        emailPlaceholder: "E-mail",

        messagePlaceholder:
            "Tell us about your project...",

        selectSubject:
            "Select a subject",

        selectBudget:
            "Estimated Budget",

        send:
            "SEND MESSAGE",

        robotConfirm:
            "Verify you are not a robot.",

        messageSentTitle:
            "Message Sent!",

        messageSentDescription:
            "We will contact you soon.",

        subjects: [
            "Develop a Project",
            "Partnership Proposal",
            "Freelance Hiring",
            "Other"
        ],

        budgets: [
            "Up to $1,000",
            "$1,000 - $3,000",
            "$3,000 - $10,000",
            "Above $10,000"
        ],

        contactInfo: {
            email:
                "blackpaladinsgames@gmail.com",

            location:
                "Brazil - Remote Work"
        },
    },
}